import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

export const safeSelector = (root: RootState) => root.events;

export const eventsSelector = createSelector(safeSelector, (events) => events.events);
export const siteEventsSelector = createSelector(safeSelector, (events) => events.siteEvents);
export const loadingEventsSelector = createSelector(safeSelector, (events) => events.loading);
export const errorEventsSelector = createSelector(safeSelector, (events) => events.error);
export const getCurrentEventSelector = createSelector(
  safeSelector,
  (events) => events.currentEvent,
);
export const loadingCurrentEventSelector = createSelector(
  safeSelector,
  (events) => events.loadingCurrentEvent,
);
export const savingCurrentEventSelector = createSelector(
  safeSelector,
  (events) => events.savingCurrentEvent,
);
export const getEventTicketsSelector = createSelector(safeSelector, (events) => events.tickets);
export const getEventOccurrencesSelector = createSelector(
  safeSelector,
  (events) => events.occurrences,
);
export const getTicketsLoadingSelector = createSelector(
  safeSelector,
  (events) => events.loadingTickets,
);
export const selectPromoList = createSelector(safeSelector, (events) => events.promos);
export const selectSearchText = createSelector(safeSelector, (events) => events.searchText);
export const selectEventsIsLoading = createSelector(safeSelector, (events) => events.loading);
export const selectTicketsIsLoading = createSelector(
  safeSelector,
  (events) => events.loadingTickets,
);
export const selectEventAttendeeStats = createSelector(
  safeSelector,
  (events) => events.eventAttendeeStats,
);
export const selectAttendees = createSelector(safeSelector, (events) => events.attendees);

// Event Hosts Selectors
export const selectEventHosts = (eventId: string) =>
  createSelector(safeSelector, (events) => events.eventHosts[eventId] || []);

export const selectActiveEventHosts = (eventId: string) =>
  createSelector(safeSelector, (events) => {
    const hosts = events.eventHosts[eventId] || [];
    return hosts.filter((host) => host.is_active);
  });

export const selectLoadingEventHosts = createSelector(
  safeSelector,
  (events) => events.loadingEventHosts,
);
